$(document).ready(function() {
	setTimeout(
		function() {
			$('.alert').not(".form-alert").hide("slow");
		}, 5000);

	$.fn.DataTable.ext.pager.numbers_length = 5;
});